import { render } from "./header.component.vue?vue&type=template&id=10a101ad&scoped=true&ts=true"
import script from "./header.component.ts?vue&type=script&lang=ts"
export * from "./header.component.ts?vue&type=script&lang=ts"

import "./header.component.vue?vue&type=style&index=0&id=10a101ad&lang=less&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a101ad"]])

export default __exports__